import { ALL_OPTIONS_VALUE } from '../filter';
import { usePersistedParam } from './use-persisted-param';
import { usePersistedParams } from './use-persisted-params';

export const useFacilityFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `facilityId`,
    type: 'number',
    defaultValue,
  });
};

export const useDepartmentFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `departmentId`,
    type: 'number',
    defaultValue,
  });
};

export const useDepartmentsFilter = (
  pageKey: string,
  allIfNoneValue?: number
) => {
  return usePersistedParams({
    pageKey,
    paramKey: `departmentIds`,
    type: 'number',
    defaultValue: allIfNoneValue ? [ALL_OPTIONS_VALUE] : [],
    allIfNoneValue,
  });
};

export const useSchedulePeriodFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `schedulePeriodId`,
    type: 'number',
  });
};

export const usePositionFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `positionId`,
    type: 'number',
    defaultValue,
  });
};

export const usePositionsFilter = (
  pageKey: string,
  allIfNoneValue?: number
) => {
  return usePersistedParams({
    pageKey,
    paramKey: `positionIds`,
    type: 'number',
    defaultValue: allIfNoneValue ? [ALL_OPTIONS_VALUE] : [],
    allIfNoneValue,
  });
};

export const useUnitFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `unitId`,
    type: 'number',
    defaultValue,
  });
};

export const useUnitsFilter = (pageKey: string, allIfNoneValue?: number) => {
  return usePersistedParams({
    pageKey,
    paramKey: `unitIds`,
    type: 'number',
    defaultValue: allIfNoneValue ? [ALL_OPTIONS_VALUE] : [],
    allIfNoneValue,
  });
};

export const useShiftTypeFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `shiftTypeId`,
    type: 'number',
    defaultValue,
  });
};

export const useQFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `q`,
    type: 'string',
    defaultValue: '',
  });
};

export const useWeekFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `week`,
    type: 'number',
    defaultValue: 1,
  });
};

export const useDraftFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `draftId`,
    type: 'number',
  });
};

export const useExpandedFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `expanded`,
    type: 'boolean',
  });
};

export const useActionsOpen = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `actionsOpen`,
    type: 'boolean',
  });
};

export const useFormatFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `format`,
    type: 'number',
    defaultValue: 0,
  });
};

export const useUnitSortByFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `unitSortBy`,
    type: 'string',
  });
};

export const useGroupByFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `groupBy`,
    type: 'number',
  });
};

export const useOrientationFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `orientation`,
    type: 'number',
  });
};
export const useCompactFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `compact`,
    type: 'number',
    defaultValue: 0,
  });
};

export const useCompareByFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `compareBy`,
    type: 'number',
    defaultValue: 0,
  });
};
export const useHppdByPositionFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `hppdByPosition`,
    type: 'number',
  });
};
export const useHeaderFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `header`,
    type: 'string',
  });
};
export const useFooterFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `footer`,
    type: 'string',
  });
};

export const usePageNumberFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `pageNumber`,
    type: 'number',
    defaultValue: 1,
  });
};

export const usePageSizeFilter = (pageKey: string, defaultValue = 10) => {
  return usePersistedParam({
    pageKey,
    paramKey: `pageSize`,
    type: 'number',
    defaultValue,
  });
};

export const useEmployeeIdFilter = (pageKey: string, defaultValue = 0) => {
  return usePersistedParam({
    pageKey,
    paramKey: `employeeId`,
    type: 'number',
    defaultValue,
  });
};

export const useDateFilter = (
  pageKey: string,
  defaultValue: null | Date = null
) => {
  return usePersistedParam({
    pageKey,
    paramKey: 'date',
    type: 'date',
    defaultValue,
  });
};

export const useStartDateFilter = (
  pageKey: string,
  defaultValue: null | Date = null
) => {
  return usePersistedParam({
    pageKey,
    paramKey: 'startDate',
    type: 'date',
    defaultValue,
  });
};

export const useEndDateFilter = (
  pageKey: string,
  defaultValue: null | Date = null
) => {
  return usePersistedParam({
    pageKey,
    paramKey: 'endDate',
    type: 'date',
    defaultValue,
  });
};

export const useGroupByShiftFilter = (pageKey: string) => {
  return usePersistedParam({
    pageKey,
    paramKey: `groupByShift`,
    type: 'boolean',
  });
};
